import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'acan-modal',
  templateUrl: './acan-modal.component.html',
  styleUrls: ['./acan-modal.component.scss'],
  standalone: false,
})
export class AcanModalComponent {
  @Input() visible = false;
  @Input() header = '';
  @Input() modal = true;
  @Input() dismissableMask = true;
  @Input() closable = true;
  @Input() draggable = false;
  @Input() resizable = false;
  @Input() width = '70vw';
  @Input() style?: Record<string, string>;
  @Input() breakpoints: Record<string, string> = { '991px': '90vw' };
  @Input() styleClass = 'pp-form--dialog';
  @Input() contentStyle?: Record<string, string>;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() hide = new EventEmitter<void>();

  get dialogStyle(): Record<string, string> {
    if (this.style) {
      return this.style;
    }
    return { width: this.width || '70vw' };
  }

  onVisibleChange(value: boolean): void {
    this.visible = value;
    this.visibleChange.emit(value);
    if (!value) {
      this.hide.emit();
    }
  }
}
